import { atom } from "recoil";

const sitesAtom = atom({
  key: "sites",
  default: [],
});

export { sitesAtom };
